export const NewProspectRoute = {
  path: '/prospect/Create',
  load: () => import('./NewProspectPage'),
  protected: true,
};

export const ProspectRoute = {
  path: '/prospect',
  load: () => import('./ProspectPage'),
  protected: true,
};

export const ProspectDetailsRoute = {
  path: '/prospect/details/:id',
  load: () => import('./prospectDetails/ProspectDetails'),
  protected: true,
};
